import config from 'config';
import { ErrorBoundary } from '@appsignal/react';
import { appsignalInstance } from 'lib/appsignal';

interface Props extends React.PropsWithChildren {
  name: string;
}

const AppSignalErrorBoundary = ({ children, name }: Props) => {
  return config.appSignal?.active ? (
    <ErrorBoundary
      action={name}
      instance={appsignalInstance}
      tags={{ client_id: config.hostname }}
    >
      {children}
    </ErrorBoundary>
  ) : (
    <>{children}</>
  );
};

export default AppSignalErrorBoundary;
